module.exports = __webpack_public_path__ + "static/media/raspberries.26a25af1.png";